module.exports = __webpack_public_path__ + "img/twitter.43449f1c.svg";